import React from "react";

import withSessionHandling from "@/context/auth/withSessionHandling";
import CacheManagementScreen from "@/screens/Settings/Troubleshooting/CacheManagementScreen";

function Page(): React.JSX.Element {
  return <CacheManagementScreen />;
}

export default withSessionHandling(Page);
